type TokenGetter = () => Promise<string | undefined>;

let getter: TokenGetter = async () => undefined;

/**
 * Bridges the Auth0 token out of React so module-level Apollo clients can use
 * it. Registered by ApolloProviderWithAuthToken, which is mounted at the app
 * root, so it is set before any query runs.
 */
export function registerAccessTokenGetter(fn: TokenGetter): void {
    getter = fn;
}

export function accessToken(): Promise<string | undefined> {
    return getter();
}
